import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import Spa from './barba/Spa';
import Menu from './components/Menu';
import Scrollocking from './components/Scrolllocking';

import LottiePlayer from './components/LottiePlayer';
import AutoplayVideos from './components/AutoplayVideos';
import AutoplayAnimations from './components/AutoplayAnimations';
import Markers from './components/Markers';

import TestWebMAlphaSupport from './components/TestWebMAlphaSupport';

import menus from './menus';

export class SuperChillPlatform {
	constructor() {
		Promise.all([SuperChillPlatform.domReady(), new TestWebMAlphaSupport().apply()]).then(() => this.init());
	}

	init() {
		// const headers = document.querySelectorAll('[data-header]');
		// headers.forEach((header) => {
		// 	new Menu(header);
		// });
		new Spa();
		new Scrollocking();
		new LottiePlayer();
		new AutoplayVideos();
		new AutoplayAnimations();
		new Markers();

		jQuery(document).on('submit', 'form[data-formid]', function (evt) {
			const el = evt.target;
			if (!el.querySelector('[name="version_hash"]')) {
				const hiddenInput = `<input
					type="hidden"
					name="version_hash"
					value="${window.gform_theme_config?.common?.form?.honeypot?.version_hash}"
				/>`;
				el.insertAdjacentHTML('beforeend', hiddenInput);
			}
		});
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new SuperChillPlatform();
